import PlaidIcon from "src/assets/PlaidIcon.svg?react";
import {
  getDefaultPlaidAssetReport,
  getDefaultPlaidFinancialInsightsReport,
  getDefaultPlaidCraBaseReport,
  getDefaultPlaidCraIncomeInsightsReport,
  getDefaultPlaidCraPartnerInsightsReport,
} from "src/connections/connectionConfigs/plaid/plaidResources";
import { PlaidTemplate } from "src/connections/connectionConfigs/plaid/plaidTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const PLAID_CONFIG: ConnectionConfig<"plaid"> = {
  icon: PlaidIcon,
  template: PlaidTemplate,
  description: "One integration, all of open banking",
  name: "Plaid",
  resources: {
    asset_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/open-banking/plaid#plaid-assets-asset-report",
      integrationResource: getDefaultPlaidAssetReport,
    },
    financial_insights_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/open-banking/plaid#plaid-assets-financial-insights-report",
      integrationResource: getDefaultPlaidFinancialInsightsReport,
    },
    plaid_cra_base_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/open-banking/plaid#plaid-check-base-report",
      integrationResource: getDefaultPlaidCraBaseReport,
    },
    plaid_cra_income_insights_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/open-banking/plaid#plaid-check-income-insights-report",
      integrationResource: getDefaultPlaidCraIncomeInsightsReport,
    },
    plaid_cra_partner_insights_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/open-banking/plaid#plaid-check-partner-insights-report",
      integrationResource: getDefaultPlaidCraPartnerInsightsReport,
    },
  },
};
